// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterLogo_link__3hA8O","image":"FooterLogo_image__DgpA8"};